/**
 * Mapeamento de acesso por rota usando permissões vindas do back-end
 * (tabelas permissions / role_permissions).
 *
 * Regras:
 * - anyOf: libera se o usuário tiver qualquer uma das permissões.
 * - allOf: libera apenas se o usuário tiver todas.
 */
export const routePermissionRulesByName = {
  register: { anyOf: ['user.insert'] },
  home: { anyOf: ['dashboard.view'] },
  'ai-chat': { anyOf: ['dashboard.view'] },
  'professional-calendar': { anyOf: ['agenda.view.professional'] },
  'customer-calendar': { anyOf: ['agenda.view.customer', 'agenda.view.pacient'] },

  abordagem: { anyOf: ['approach.view'] },
  agencia: { anyOf: ['agencia.view'] },
  Atendimentos: { anyOf: ['atendimento.view'] },
  SchedulingRequests: { anyOf: ['scheduling-request.view', 'atendimento.view'] },
  AuthorizeAttendances: { anyOf: ['atendimento.view'] },
  'accounts-payable': {
    anyOf: ['conta-pagar.view', 'conta-pagar.edit'],
  },
  'accounts-receivable': {
    anyOf: ['conta-receber.view', 'conta-receber.edit'],
  },
  billing: { anyOf: ['faturamento.evolucoes.view'] },
  'faturamento-evolucoes': { anyOf: ['faturamento.evolucoes.view'] },
  nfse: { anyOf: ['nfse.preview', 'nfse.documents.view'] },
  'validation-recurrence': {
    anyOf: ['financeiro.validacao-evolucoes.view', 'atendimento.view'],
  },
  SessoesMensais: { anyOf: ['atendimento.view'] },
  calendar: { anyOf: ['agenda.view'] },
  'medical-records': { anyOf: ['medical-records.view'] },
  'parametros-centrocusto': { anyOf: ['dashboard.view'] },
  'parametros-centroresultado': { anyOf: ['dashboard.view'] },
  'parametros-cidades': { anyOf: ['cidade.view'] },
  'parametros-nfse-clinicas': { anyOf: ['nfse.config.manage'] },
  convenio: { anyOf: ['agreement.view'] },
  Empresas: { anyOf: ['empresa.view'] },
  Ficha: { anyOf: ['atendimento.report'] },
  RepasseProfissionais: { anyOf: ['relatorio.resumo-repasse', 'atendimento.report'] },
  InvoiceIssuanceReport: { anyOf: ['faturamento.evolucoes.view'] },
  InvoiceIssuanceTable: { anyOf: ['faturamento.evolucoes.view'] },
  AccountsPayablePaid: { anyOf: ['conta-pagar.view', 'conta-pagar.edit'] },
  AccountsReceivableReceived: { anyOf: ['conta-receber.view', 'conta-receber.edit'] },
  'cash-flow-report': { anyOf: ['atendimento.report'] },
  ResumoRepasseProfissional: { anyOf: ['relatorio.resumo-repasse', 'atendimento.report'] },
  'parametros-historicopadrao': { anyOf: ['dashboard.view'] },
  Pacients: { anyOf: ['pacient.view'] },
  'plan-accounts': { anyOf: ['plano-conta.view', 'dashboard.view'] },
  Professionals: { anyOf: ['professional.view'] },
  Responsibles: { anyOf: ['responsable.view'] },
  'parametros-tipospagamento': { anyOf: ['dashboard.view'] },
  tratamento: { anyOf: ['treatment.view'] },
  'parametros-unidademed': { anyOf: ['dashboard.view'] },
  userGetAll: { anyOf: ['user.view'] },
  permissions: { anyOf: ['permission.view'] },
  'permission-edit': { anyOf: ['permission.edit'] },
  'audit-log': { anyOf: ['user.view'] },
  'activate-device': { anyOf: ['user.view'] },
  'atendimento.view.professional': { anyOf: ['atendimento.view.professional'] },
  'tv-chamar-pacientes': { anyOf: ['dashboard.view'] },
  'monthly-session-limits': { anyOf: ['atendimento.edit'] },
  'tv-devices': { anyOf: ['user.edit'] },
}

export function getRoutePermissionRule(route) {
  if (!route || !route.name) {
    return null
  }
  return routePermissionRulesByName[route.name] || null
}

const routePermissionRulesByPath = {
  '/financeiro/faturamento': routePermissionRulesByName.billing,
  '/financeiro/faturamento-evolucoes': routePermissionRulesByName['faturamento-evolucoes'],
  '/financeiro/nfse': routePermissionRulesByName.nfse,
  '/parametros/nfse-clinicas': routePermissionRulesByName['parametros-nfse-clinicas'],
  '/medical-records': routePermissionRulesByName['medical-records'],
  '/cadastros/responsibles': routePermissionRulesByName.Responsibles,
}

export function getRoutePermissionRuleByPath(path) {
  if (!path) {
    return null
  }
  return routePermissionRulesByPath[path] || null
}
